<template>
	<div>
		<div style="padding-bottom:44px;">
			<el-col :span="6">
				<el-input v-model="companyName" class="" placeholder="公司名称"></el-input>
			</el-col>
			<el-col :span="6">
				<el-button type="primary" @click="searchApply">查询</el-button>
			</el-col>
		</div>
		<el-table :data="tableData" style="width: 100%;margin-top:10px;" border stripe>
			<el-table-column prop="id" label="编号" width="50"></el-table-column>
      		<el-table-column prop="companyName" label="公司名称" width="180"></el-table-column>
      		<el-table-column prop="realName" label="姓名" width="120"></el-table-column>
      		<el-table-column prop="telephone" label="联系电话" width="150"></el-table-column>
      		<el-table-column prop="bussniess" label="线路/服务" width="180"></el-table-column>
      		<el-table-column prop="address" label="公司地址" width="180"></el-table-column>
      		<el-table-column prop="createTime" label="申请时间" width="160"></el-table-column>
      		<el-table-column label="操作" width="250">
      			<template scope="scope">
					<el-button size="small" @click="auditingToLine(scope.$index, scope.row)">添加线路</el-button>
					<el-button size="small" @click="auditingToEquip(scope.$index, scope.row)">添加装备</el-button>
				</template>
      		</el-table-column>
      	</el-table>
      	<el-pagination background ayout="prev, next" @current-change="handlerCurrentPage"  :page-size="pageSize" :total="total">
		</el-pagination>


		
	</div>

	
</template>
<script >
	import {getApplyList} from "@/api/api"
	export default {
		data(){
		 	return {
		 		tableData:[],
		 		companyName:"",
		 		pageSize:15,

		 		total:0,
		 		pageCount:0
		 	}
		},
		created:function() {
			var _this = this;
			let params = {pageNum:0,pageSize:this.pageSize};
			getApplyList(params).then(res =>{
				this.tableData = res.data.data.list;
				this.total = res.data.data.total;
				this.pageCount=res.data.data.pages;
			});
			
		},
		methods:{
			searchApply(){
				this.reload();
			},
			handlerCurrentPage(currentPage){
				let params = {pageNum:currentPage,pageSize:this.pageSize};
				getApplyList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
				});
			},
			reload(){
				console.log("reload");
				let params = {pageNum:this.currentPage,pageSize:this.pageSize,companyName:this.companyName};
				getApplyList(params).then(res =>{
					this.tableData = res.data.data.list;
					this.total = res.data.data.total;
					this.pageCount = res.data.data.pages;
					this.currentPage = res.data.data.pageNum;
				});
			},
			auditingToLine(index,row){
				this.$router.push({name:"applyForLine",params:row});
			},
			auditingToEquip(index,row){
				this.$router.push({name:"applyForEquip",params:row});
			}
		}
	}
</script>